"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'branch.search.placeholder': 'Search branches...',
};
